<template>
  <SuggestionButton 
    :content-id="contentId" 
    :content-model="contentModel" 
    :content-type="contentType" 
    :content-category="contentCategory"
    :current-text="currentText"
    :current-image-url="currentImageUrl"
    :current-video-url="currentVideoUrl"
    :button-text="buttonText"
    :icon="icon"
    :color="color"
    :size="size"
    @suggestion-created="handleSuggestionCreated"
  />
</template>

<script setup>
import { computed } from 'vue'
import { useContentStore } from '@/stores/content'
import SuggestionButton from '@/components/suggestions/components/SuggestionButton.vue'

const contentStore = useContentStore()

// Store'dan content ID'sini al
const contentId = computed(() => contentStore.getSelectedContentId)

const props = defineProps({
  contentModel: {
    type: String,
    required: true,
  },
  contentType: {
    type: String,
    required: true,
  },
  contentCategory: {
    type: String,
    required: true,
  },
  currentText: {
    type: String,
    default: '',
  },
  currentImageUrl: {
    type: String,
    default: '',
  },
  currentVideoUrl: {
    type: String,
    default: '',
  },
  buttonText: String,
  icon: String,
  color: String,
  size: String,
})

const emit = defineEmits(['suggestion-created'])

const handleSuggestionCreated = (suggestion) => {
  emit('suggestion-created', suggestion)
}
</script>
